// extracted by mini-css-extract-plugin
module.exports = {"descriptionText":"MetricsPage_descriptionText__2oc3y"};